import { createFileRoute } from "@tanstack/react-router";
import { ScreenPage } from "@/components/dashboard/screen-page";
export const Route = createFileRoute("/roles")({
 head:()=>({meta:[{title:"Roles and authorizations — Deuxda Admin"},{name:"description",content:"Granular access control for the Deuxda team."},{property:"og:title",content:"Roles and authorizations — Deuxda Admin"},{property:"og:description",content:"Granular access control for the Deuxda team."},{property:"og:type",content:"website"},{name:"twitter:card",content:"summary_large_image"}]}),
 component:()=> <ScreenPage screen="roles"/>,
});
